import LocationIcon from "../../icons/location.svg"
import PhoneIcon from "../../icons/phone.svg"
import EmailIcon from "../../icons/email.svg"
import "./HowToFind.scss"

const HowToFind = () => {
  const address = "Tulpių g. 20B, Karmėlava, Kauno rajonas";

  return (
    <section id="how-to-find-section">
      <div className="how-to-find-contacts-container">
        <h2 className="how-to-find-header">Kontaktai</h2>
        <div className="contact-container">
          <div className="icon-container">
            <img src={PhoneIcon} alt="Phone" />
          </div>
          <div>
            <div className="contact-title">Phone</div>
            <div className="contact-value">+370 600 11 103</div>
          </div>
        </div>

        <div className="contact-container">
          <div className="icon-container">
            <img src={EmailIcon} alt="Email" />
          </div>
          <div>
            <div className="contact-title">Email</div>
            <div className="contact-value">info@parknfly.lt</div>
          </div>
        </div>
        <div className="contact-container">
          <div className="icon-container">
            <img src={LocationIcon} alt="Location" />
          </div>
          <div>
            <div className="contact-title">Address</div>
            <div className="contact-value">{address}</div>
          </div>
        </div>

      </div>
      <div className="map-container">
        <iframe
          loading="lazy"
          className="google-map"
          title="Kauno Oro Uostas Parkavimo Aikštelė"
          src="https://www.google.com/maps/embed/v1/place?key=AIzaSyA5NKtZFkNxzDO75yL5NouClTq1K_VvIPQ&q=ParkNFly,+Kaunas&zoom=16"
          referrerPolicy="no-referrer-when-downgrade"
          allowFullScreen
        ></iframe>
      </div>
    </section>
  );
};

export default HowToFind